export const includesOrEmpty = (itemToTest: string, allowedItems: string[]) => {
  return (allowedItems.length === 0 || allowedItems.find(item => item === itemToTest) != undefined);
};

export const excludesOrEmpty = (itemToTest: string, disallowedItems: string[]) => {
  return (disallowedItems.length === 0 || disallowedItems.find(item => item === itemToTest) == undefined);
};

/**
 * Facilitates navigating through an array of items and maintaining a current item
 */
export class ArrayNavigator<T> {
  private idx: number;
  constructor(private readonly data: Array<T>) {
    if (!data || data.length === 0) return;
    this.idx = 0;
  }

  get hasData() { return this.data != undefined }

  get hasMultipleItems() { return this.hasData && this.data.length > 1 }

  next() {
    this.idx++;
    if (this.idx >= this.data.length ) {
      this.idx = 0;
    }
  }

  prev() {
    this.idx--;
    if (this.idx < 0) {
      this.idx = this.data.length - 1;
    }
  }

  get current(): T {
    return this.idx !== undefined ? this.data[this.idx] : undefined;
  }

}
